import heic2any from 'heic2any'
const projectName = 'ask-price'
import Cookies from 'js-cookie'
/**
 * 手机号合法校验
 * @param {string|number} phoneNum
 * @returns {boolean}
 */
export const isValidMobile = function (phoneNum) {
  return /^1[3456789]\d{9}$/.test(phoneNum)
}

/**
 * 身份证合法校验
 * @param {string} num
 * @returns
 */
export const isValidID = function (num) {
  num = num.toUpperCase()
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
    return false
  }
  //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
  var len, re
  len = num.length
  if (len == 15) {
    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/)
    var arrSplit = num.match(re)
    //检查生日日期是否正确
    var dtmBirth = new Date(
      '19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]
    )
    var bGoodDay
    bGoodDay =
      dtmBirth.getYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4])
    if (!bGoodDay) {
      return false
    } else {
      //将15位身份证转成18位
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      var arrInt = new Array(
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1,
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2
      )
      var arrCh = new Array(
        '1',
        '0',
        'X',
        '9',
        '8',
        '7',
        '6',
        '5',
        '4',
        '3',
        '2'
      )
      var nTemp = 0,
        i
      num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6)
      for (i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i]
      }
      num += arrCh[nTemp % 11]
      return num
    }
  }
  if (len == 18) {
    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/)
    var arrSplit = num.match(re)
    //检查生日日期是否正确
    var dtmBirth = new Date(arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4])
    var bGoodDay
    bGoodDay =
      dtmBirth.getFullYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4])
    if (!bGoodDay) {
      return false
    } else {
      //检验18位身份证的校验码是否正确。
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      var valnum
      var arrInt = new Array(
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1,
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2
      )
      var arrCh = new Array(
        '1',
        '0',
        'X',
        '9',
        '8',
        '7',
        '6',
        '5',
        '4',
        '3',
        '2'
      )
      var nTemp = 0,
        i
      for (i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i]
      }
      valnum = arrCh[nTemp % 11]
      if (valnum != num.substr(17, 1)) {
        return false
      }
      return num
    }
  }
  return false
}

/**
 * 姓名合法校验
 * @param {string} name
 * @returns
 */
export const isValidName = function (name) {
  return /^[\u4E00-\u9FA5]{2,4}$/.test(name)
}

/**
 * 手机号前3后4脱敏
 * @param {*} phone
 * @returns
 */
export const phoneDes = function (phone) {
  if (phone && isValidMobile(phone)) {
    return phone.slice(0, 3) + '****' + phone.slice(-4)
  }
  return ''
}
/*
  身份证前3后2脱敏
*/
export const idCardDes = function (idCard) {
  if (idCard && isValidID(idCard)) {
    return idCard.slice(0, 3) + '*************' + idCard.slice(-2)
  }
  return ''
}

/**
 * 保留最后一个字
 * @param {string} name
 * @returns
 */
export const nameDes = function (name) {
  if (name && isValidName(name)) {
    let arr = '**********'
    return arr.slice(0, name.length - 1) + name.slice(-1)
  }
}

/**
 * 保留第一个字
 * @param {string} name
 * @returns
 */
export const nameDesFirst = function (name) {
  if (name && isValidName(name)) {
    let arr = '****************'
    return name.slice(0, 1) + arr.slice(0, name.length - 1)
  }
}

/**
 * 倒计时代码
 * @param {string} pname 用来展示倒计时文本的变量
 */
export const countdown = function (pname, context) {
  let count = 60
  context[pname] = count + 's'
  let timer = setInterval(() => {
    console.log('interval')
    if (count === 0) {
      context[pname] = '发送验证码'
      clearInterval(timer)
    } else {
      count--
      context[pname] = count + 's'
    }
  }, 1000)
  return timer
}
export const saveImg = function (url) {
  $flutter.fbDownload({
    data: {
      url,
    },
    success: (res) => {
      console.log('success', res)
    },
    error: (res) => {
      console.log('error', res)
    },
  })
}

/**
 * 唤醒微信
 */
export const wakeUpWeChat = function () {
  window.location.href = 'weixin://'
}
/**
 * 判断是否微信环境
 */
export const isWeChat = function () {
  return /MicroMessenger/gi.test(navigator.userAgent)
}

/**
 * 获取链接参数
 * @param {string} name 需要获取的参数名
 * @returns {string | null}
 */
export const getUrlParam = function (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let matchedArr = window.location.search.substr(1).match(reg)
  if (matchedArr) return decodeURIComponent(matchedArr[2])
  return null
}

/**
 * 获取当前日期 格式化yyyyMMddhhmmss
 * @param {Date} date Date实例
 * @returns
 */
export const formatDate = function (date, hms) {
  let o = {
    y: date.getFullYear(),
    M: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
  }
  let now = ''
  for (let key in o) {
    let value = String(o[key])
    if (value.length === 1) {
      o[key] = '0' + value
    }
  }
  now = `${o.y}-${o.M}-${o.d} ${o.h}:${o.m}:${o.s}`
  if (hms) {
    return now
  } else {
    return now.split(' ')[0]
  }
}

/**
 * 通过身份证获取年龄
 * @param {*} identityCard 身份证号
 * @param {*} proposalDate 与身份证出生日期相比较的日期 yyyy-mm-dd
 * @returns
 */
export const getAge = function (identityCard, proposalDate) {
  if (proposalDate) proposalDate = proposalDate.replace(/-/g, '/')
  var len = (identityCard + '').length
  if (len == 0) {
    return 0
  } else {
    if (len != 15 && len != 18) {
      //身份证号码只能为15位或18位其它不合法
      return 0
    }
  }
  var strBirthday = ''
  if (len == 18) {
    //处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday =
      identityCard.substr(6, 4) +
      '/' +
      identityCard.substr(10, 2) +
      '/' +
      identityCard.substr(12, 2)
  }
  if (len == 15) {
    strBirthday =
      '19' +
      identityCard.substr(6, 2) +
      '/' +
      identityCard.substr(8, 2) +
      '/' +
      identityCard.substr(10, 2)
  }
  //时间字符串里，必须是“/”
  var birthDate = new Date(strBirthday)
  var nowDateTime = ''
  if (proposalDate == undefined) {
    nowDateTime = new Date()
  } else {
    nowDateTime = new Date(proposalDate)
  }
  var age = nowDateTime.getFullYear() - birthDate.getFullYear()
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (
    nowDateTime.getMonth() < birthDate.getMonth() ||
    (nowDateTime.getMonth() == birthDate.getMonth() &&
      nowDateTime.getDate() < birthDate.getDate())
  ) {
    age--
  }
  return age
}

export const getTomorrow = function () {
  const today = new Date()
  today.setTime(today.getTime() + 24 * 60 * 60 * 1000)
  let y = String(today.getFullYear())
  let m = String(today.getMonth() + 1)
  let d = String(today.getDate())
  if (m.length === 1) m = '0' + m
  if (d.length === 1) d = '0' + d
  return y + '/' + m + '/' + d
}

export const getOffsetDay = function (date, day = 0) {
  // const today = new Date()
  let result = new Date()
  result.setTime(date.getTime() + day * 24 * 60 * 60 * 1000)
  let y = String(result.getFullYear())
  let m = String(result.getMonth() + 1)
  let d = String(result.getDate())
  if (m.length === 1) m = '0' + m
  if (d.length === 1) d = '0' + d
  return y + '/' + m + '/' + d
  // return result.getTime()
}

export const getToken = function () {
  let token = localStorage.getItem(projectName + '-token')
  if (token) {
    return token
  }
  return null
}
export const setToken = function (token) {
  localStorage.setItem(projectName + '-token', token)
}

export const getUsername = function () {
  let username = localStorage.getItem(projectName + '-username')
  if (username) {
    return username
  }
  return null
}

export const setUsername = function (username) {
  localStorage.setItem(projectName + '-username', username)
}
//设置userid
export const setUserId = function (userId) {
  return localStorage.setItem('userId', userId)
}
export const getUserId = function () {
  return localStorage.getItem('userId')
}
export const getRole = function () {
  let role = localStorage.getItem(projectName + '-role')
  if (role) {
    return role
  }
  return null
}

export const setRole = function (role) {
  localStorage.setItem(projectName + '-role', role)
}

export const getModel = function () {
  let model = JSON.parse(localStorage.getItem(projectName + '-model'))
  if (model) {
    return model
  } else {
    return {
      list: [
        {
          count: 1,
        },
      ],
    }
  }
}

export const setTodoList = function (data) {
  localStorage.setItem('todo-list', data)
}

export const getTodoList = function () {
  let list = JSON.parse(localStorage.getItem('todo-list'))
  if (list) {
    return list
  } else {
    return null
  }
}

export const setNotifyRecords = function (data) {
  localStorage.setItem('notify-records', data)
}
export const getNotifyRecords = function () {
  let records = JSON.parse(localStorage.getItem('notify-records'))
  if (records) {
    return records
  } else {
    return null
  }
}

export const setModel = function (model) {
  localStorage.setItem(projectName + '-model', JSON.stringify(model))
}

export const getAccount = function () {
  let acc = JSON.parse(localStorage.getItem(projectName + '-acc'))
  if (acc) {
    return acc
  }
  return null
}
export const userSource = function () {
  let accInfo = getAccount()
  if (accInfo) {
    return accInfo.source
  } else {
    return 999
  }
}
export const setAccount = function (info) {
  localStorage.setItem(projectName + '-acc', JSON.stringify(info))
}

export const setFirstInto = function (isFirstInto) {
  Cookies.set(projectName + 'firstinfo', isFirstInto, { expires: 7 })
}
export const getFirstInto = function () {
  return Cookies.get(projectName + 'firstinfo')
}
export const getRoutes = function () {
  let routes = JSON.parse(localStorage.getItem(projectName + '-routes'))
  if (routes) {
    return routes
  }
  return null
}

export const setRoutes = function (routes) {
  localStorage.setItem(projectName + '-routes', JSON.stringify(routes))
}

export const getIndex = function () {
  let p_index = localStorage.getItem(projectName + '-index')
  if (p_index) {
    return p_index
  } else {
    return 0
  }
}

export const setIndex = function (index) {
  localStorage.setItem(projectName + '-index', index)
}

export const clearUserInfo = function () {
  let keys = Object.keys(localStorage)
  keys.forEach((item) => {
    if (item.includes(projectName)) {
      localStorage.removeItem(item)
    }
  })
}
export const removeOrder = function () {
  localStorage.removeItem(projectName + '-model')
  localStorage.removeItem(projectName + '-index')
}

export var browser = {
  versions: (function () {
    var u = navigator.userAgent
    return {
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == ' qq', //是否QQ
    }
  })(),
}
export var compressImg = (file, quality) => {
  var qualitys = 0.52
  console.log(parseInt((file.size / 1024).toFixed(2)))
  if (parseInt((file.size / 1024).toFixed(2)) < 1024) {
    qualitys = 0.85
  }
  if (5 * 1024 < parseInt((file.size / 1024).toFixed(2))) {
    qualitys = 0.92
  }
  if (quality) {
    qualitys = quality
  }
  if (file[0]) {
    return Promise.all(
      Array.from(file).map((e) => this.compressImg(e, qualitys))
    ) // 如果是 file 数组返回 Promise 数组
  } else {
    return new Promise((resolve) => {
      // console.log(file)
      if ((file.size / 1024).toFixed(2) < 300) {
        resolve({
          file: file,
        })
      } else {
        const reader = new FileReader() // 创建 FileReader
        const readerBuffer = new FileReader()
        reader.onload = (e) => {
          // console.log(e)
          const image = new Image() // 创建 img 元素
          image.onload = () => {
            const canvas = document.createElement('canvas') // 创建 canvas 元素
            const context = canvas.getContext('2d')
            var targetWidth = image.width
            var targetHeight = image.height
            var originWidth = image.width
            var originHeight = image.height
            if (
              1 * 1024 <= parseInt((file.size / 1024).toFixed(2)) &&
              parseInt((file.size / 1024).toFixed(2)) <= 10 * 1024
            ) {
              var maxWidth = 1600
              var maxHeight = 1600
              targetWidth = originWidth
              targetHeight = originHeight
              // 图片尺寸超过的限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更宽，按照宽度限定尺寸
                  targetWidth = maxWidth
                  targetHeight = Math.round(
                    maxWidth * (originHeight / originWidth)
                  )
                } else {
                  targetHeight = maxHeight
                  targetWidth = Math.round(
                    maxHeight * (originWidth / originHeight)
                  )
                }
              }
            }
            if (
              10 * 1024 <= parseInt((file.size / 1024).toFixed(2)) &&
              parseInt((file.size / 1024).toFixed(2)) <= 20 * 1024
            ) {
              maxWidth = 1400
              maxHeight = 1400
              targetWidth = originWidth
              targetHeight = originHeight
              // 图片尺寸超过的限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更宽，按照宽度限定尺寸
                  targetWidth = maxWidth
                  targetHeight = Math.round(
                    maxWidth * (originHeight / originWidth)
                  )
                } else {
                  targetHeight = maxHeight
                  targetWidth = Math.round(
                    maxHeight * (originWidth / originHeight)
                  )
                }
              }
            }
            canvas.width = targetWidth
            canvas.height = targetHeight
            context.clearRect(0, 0, targetWidth, targetHeight)
            context.drawImage(image, 0, 0, targetWidth, targetHeight) // 绘制 canvas
            const canvasURL = canvas.toDataURL('image/jpeg', qualitys)
            const buffer = atob(canvasURL.split(',')[1])
            let length = buffer.length
            const bufferArray = new Uint8Array(new ArrayBuffer(length))
            while (length--) {
              bufferArray[length] = buffer.charCodeAt(length)
            }
            const miniFile = new File([bufferArray], file.name, {
              type: 'image/jpeg',
            })
            console.log('after', Number((miniFile.size / 1024).toFixed(2)))
            resolve({
              file: miniFile,
              origin: file,
              beforeSrc: e.target.result,
              afterSrc: canvasURL,
              beforeKB: Number((file.size / 1024).toFixed(2)),
              afterKB: Number((miniFile.size / 1024).toFixed(2)),
            })
          }
          image.src = e.target.result
        }
        // reader.readAsDataURL(file);
        readerBuffer.onload = (e) => {
          const type = getFileType(readerBuffer)
          if (type === 'unknown') {
            console.error('unknown image type')
            resolve({
              file: null,
              url: '',
            })
            return
          }
          if (type.includes('/heic')) {
            console.log('heic')
            heic2any({ blob: file, toType: 'image/jpeg' })
              .then((blob) => {
                reader.readAsDataURL(blob)
              })
              .catch(() => {
                resolve({
                  file: null,
                  url: '',
                })
              })
            return
          }
          reader.readAsDataURL(file)
        }
        readerBuffer.readAsArrayBuffer(file)
      }
    })
  }
}

function getFileType(reader) {
  const bufferInt = new Uint8Array(reader.result)
  const arr = bufferInt.slice(0, 4) // 通用格式图片
  const headerArr = bufferInt.slice(0, 16) // heic格式图片
  let header = ''
  let allHeader = ''
  let realMimeType

  for (let i = 0; i < arr.length; i++) {
    header += arr[i].toString(16) // 转成16进制的buffer
  }

  for (let i = 0; i < headerArr.length; i++) {
    allHeader += headerArr[i].toString(16)
  }
  // magic numbers: http://www.garykessler.net/library/file_sigs.html
  switch (header) {
    case '89504e47':
      realMimeType = 'image/png'
      break
    case '47494638':
      realMimeType = 'image/gif'
      break
    case 'ffd8ffDB':
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      realMimeType = 'image/jpeg'
      break
    case '00020': // heic开头前4位可能是00020也可能是00018，其实这里应该是判断头尾000的，可以自己改下
    case '00018':
      allHeader.lastIndexOf('68656963') === 13 ||
      allHeader.lastIndexOf('68656966') === 13
        ? (realMimeType = 'image/heic')
        : (realMimeType = 'unknown')
      break
    default:
      realMimeType = 'unknown'
      break
  }
  return realMimeType
}
export const handleAwait = function (promise) {
  return promise
    .then((data) => {
      return [data, undefined]
    })
    .catch((error) => {
      return Promise.resolve([undefined, error])
    })
}

// export const isChinese = function (str) {
//   return /^[\u4E00-\u9FA5]/g.test(str)
// }

export const isVin = function (str) {
  return /^[A-HJ-NPR-Z\d]{17}$/.test(str)
}
